<bfx-close></bfx-close>
<div class="auth__login__panel" nativeDesktopClass="desktop">
  <div fxLayout="row" fxLayoutAlign="space-around start" class="auth__login__panel__header">
    <div fxFlex="50" class="auth__login__panel__header-logo">
      <bfx-logo-svg></bfx-logo-svg>
    </div>
    <div fxFlex="45" class="auth__login__panel__header-title">{{ frameTag }}</div>
    <div fxFlex="5" class="auth__login__panel__header-status">
      <div
        class="status"
        [ngClass]="{
          none: connectionStatus === 0,
          online: connectionStatus === 1 || connectionStatus === 5,
          offline: connectionStatus === 2 || connectionStatus === 4,
          error: connectionStatus === 3,
        }"
      >
        <span
          [bfxTooltip]="connectionStatusText"
          tooltipPosition="top"
          tooltipStyleClass="auth__login__panel__header-tooltip"
        ></span>
        <!--  -->
      </div>
    </div>
  </div>
  <div
    *ngIf="openFin"
    class="openfin auth__login__panel__body"
    [ngClass]="{ app_wrapper: true, nativeDesktop: nativeDesktop }"
  >
    <div>
      <h1>Warning</h1>
      <p>This version is no longer supported.</p>
      <p>
        Please download the new version by clicking
        <a href="/install/{{ downloadBundle }}">here</a> and follow the setup instructions.
      </p>
    </div>
  </div>
  <div [style.display]="openFin ? 'none' : ''" class="auth__login__panel__body">
    <form class="auth__login__form">
      <div class="auth__login__form__group">
        <label for="username" class="auth__login__form__label">Username</label>
        <input
          id="username"
          #userName
          class="auth__login__form__input"
          type="text"
          name="username"
          [(ngModel)]="user.username"
          (ngModelChange)="validateUserName()"
          (keyup.enter)="enterLogin()"
          spellcheck="false"
          autocomplete="username"
          [disabled]="control.lockInput"
          required
        />
      </div>
      <div class="login-error-message">{{ loginErrors[0] }}</div>
      <div class="auth__login__form__group">
        <label for="password" class="auth__login__form__label">Password</label>
        <input
          id="password"
          class="auth__login__form__input"
          type="password"
          name="password"
          (keyup.enter)="enterLogin()"
          [(ngModel)]="user.password"
          (ngModelChange)="validatePassword()"
          [disabled]="control.lockInput"
          [bfxTooltip]="capsLockStatusText"
          tooltipEvent="focus"
          autocomplete="current-password"
          tooltipPosition="top"
          required
        />
      </div>
      <div class="login-error-message">{{ loginErrors[1] }}</div>
      <div
        class="sectionLoader"
        [@loadingAnimation]="'active'"
        *ngIf="control.authLoading"
        fxLayout="row"
        fxLayoutAlign="space-around center"
      ></div>
      <div *ngIf="control.authLoading">
        <bfx-progressbar
          [autoValue]="true"
          [showLabel]="true"
          type="warning"
          label="Authenticating....."
          [autoValueInterval]="2"
          [autoValueSpeed]="50"
        ></bfx-progressbar>
      </div>
      <button
        class="auth__login__btn auth__login__btn-block bfx-button-positive"
        pButton
        type="button"
        [label]="control.authSignIn"
        (click)="login()"
        [class.btnDisabled]="control.authLoading || control.lockSignIn"
        [disabled]="control.authLoading || control.lockSignIn"
      ></button>
      <div
        class="sectionErrorMessage"
        fxLayout="row"
        fxLayoutAlign="space-around start"
        *ngIf="!control.authLoading && control.authError"
        [@errorMessageAnimation]="'active'"
      >
        <div fxFlex="17" class="authErrorIconSpacing">
          <i
            class="fa icon_ion_lock_filled fa-3x"
            aria-hidden="true"
            fxLayoutAlign="center center"
          ></i>
        </div>
        <div class="authErrorTextSpacing" fxFlex="83" fxLayout="column" fxLayoutAlign="start start">
          <div fxFlex="30" class="title">
            {{ control.authErrorTitle | uppercase }}
          </div>
          <div fxFlex="70" class="text" [innerHTML]="control.authErrorMsg"></div>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="!openFin" class="auth__login__panel__footer">
    <div class="auth__login__disclaimer auth__login__disclaimer--tag"></div>
    <div *ngIf="this.control.showDisclaimer">
      <textarea
        [rows]="5"
        pInputTextarea
        id="login-disclaimer"
        class="auth__login__disclaimer"
        [(ngModel)]="control.disclaimerTxt"
        [disabled]="true"
      >
      </textarea>
    </div>
    <p
      class="copyright"
      *ngIf="this.control.showDownloadLink"
      [innerHTML]="control.downloadLink"
    ></p>
    <p class="copyright">&copy; BarracudaFX</p>
  </div>
</div>
